/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import bind from "bind-decorator";
import store from "src/redux/store";
import {
  selectCheckSession,
  selectCheckSessionExpiration,
  selectRefreshTokenPending,
} from "src/services/vk/selectors";
import { RefreshToken } from "src/services/vk/redux";
import { ECommState } from "src/types/redux";
import {
  AxiosInterceptorManager,
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError,
} from "axios";
import { ResponseType } from "../../types/api";
import { IRestServices } from "../types";

export interface IGuExternalLinkResponse {
  url: string;
}

export interface IGetAccessTokenResponse {
  access_token: string;
  refresh_token: string;
  expires_in: number;
}
export interface IGetRefreshTokenResponse {
  access_token: string;
  refresh_token: string;
  expires_in: number;
}

export default class GuOAuth {
  constructor(private services: IRestServices) {
    this.createAuthSessionGuard();
  }

  createAuthSessionGuard() {
    const { refreshTokenHandle } = this;
    // this.services.root.interceptors.request.use(refreshTokenHandle);
  }

 private getCurrentURL(): string {
    return store.getState().addresses.apiBase
 }

  refreshTokenHandle = (config: AxiosRequestConfig) => {
    // Do something before request is sent
    const state = store.getState();
    const isAuth = selectCheckSession(state);
    const isRefreshTokenPending = selectRefreshTokenPending(state);
    const expiration = selectCheckSessionExpiration(state);

    const isAuthorizationRequest = config.url.includes("authorization");

    if (
      !isAuthorizationRequest &&
      !isRefreshTokenPending &&
      isAuth &&
      expiration < 3
    ) {
      store.dispatch(RefreshToken.pending());
    }

    return config;
  };

  @bind
  async getExternalLink(
    vk_app_id: string,
    platform: string,
    version: string,
    is_dev: boolean | string
  ): Promise<ResponseType<IGuExternalLinkResponse>> {
    const params = {
      vk_app_id,
      platform,
      version,
      is_dev,
    };

    console.log('request external link, params: \n', JSON.stringify(params, null, 2));
    return this.services.root.get<IGuExternalLinkResponse>(
      // `/shared/v1/miniapps/v1/gu-external-link`,
      `/auth/deeplink`,
      // `/gu-external-link`,
      {
        params,
      }
    );
  }

  @bind
  async getAccessToken(
    vk_app_id: string | number,
    code: string
  ): Promise<ResponseType<IGetAccessTokenResponse>> {
    const params = {
      vk_app_id,
      code,
    };

    return this.services.root.post<IGetAccessTokenResponse>(
      // `/shared/v1/authorization/access-token-by-authorization-code`,
      `/auth/login`,
      null, // empty body, just query parameters
      {
        params,
      }
    );
  }

  @bind
  async getRefreshToken(
    vk_app_id: string,
    refreshToken: string
  ): Promise<ResponseType<IGetRefreshTokenResponse>> {
    const params = {
      vk_app_id,
      access_token: refreshToken,
    };

    return this.services.root.get<IGetRefreshTokenResponse>(
      `/shared/v1/authorization/access-token`,
      {
        params,
      }
    );
  }
}
